'use client';
import '@mux/mux-player/themes/gerwig';
export default 'gerwig';
